/*
 * @Author: gaobin
 * @Date: 2025-01-14 16:36:09
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-09 14:46:54
 * @Description: 导出store
 */
import { createStore } from 'vuex';

import actions from './actions.js';
import getters from './getters';
import address from './modules/address.js';
import globalInfo from './modules/global.js';
import permission from './modules/permission.js';
import safeArea from './modules/safe-area.js';
import user from './modules/user.js';

export default createStore({
  modules: {
    user,
    safeArea,
    permission,
    address,
    globalInfo,
  },
  state: {},
  mutations: {},
  actions,
  getters,
});
